export default [
  // weapons
  {
    damage: 5,
    effect: 'damage',
    element: 'water',
    icon: 'dagger',
    name: 'ocean dagger',
    price: 6,
    set: 2,
    size: '14px',
  },
  {
    damage: 6,
    effect: 'damage',
    element: 'fire',
    icon: 'sword',
    name: 'flaming sword',
    price: 7,
    set: 2,
    size: '13px',
  },
  {
    damage: 7,
    effect: 'damage',
    element: 'poison',
    icon: 'bow',
    name: 'dread bow',
    price: 8,
    set: 2,
  },

  // magic
  {
    cost: 6,
    damage: 7,
    effect: 'damage',
    element: 'fire',
    icon: 'magic',
    name: 'explosion',
    price: 7,
    set: 2,
  },
  {
    cost: 6,
    damage: 7,
    effect: 'damage',
    element: 'electric',
    icon: 'magic',
    name: 'shock sphere',
    price: 7,
    set: 2,
    size: '14px',
  },
  {
    cost: 7,
    damage: 8,
    effect: 'damage',
    element: 'nature',
    icon: 'magic',
    name: 'stone wall',
    price: 8,
    set: 2,
  },

  // armor
  {
    armor: 7,
    effect: 'armor',
    icon: 'gloves',
    name: 'silver gloves',
    price: 6,
    set: 2,
    size: '13px',
  },
  {
    armor: 8,
    effect: 'armor',
    icon: 'helm',
    name: 'silver helm',
    price: 7,
    set: 2,
  },
  {
    armor: 9,
    effect: 'armor',
    icon: 'breastplate',
    name: 'silver chest',
    price: 8,
    set: 2,
    size: '15px',
  },

  // items
  {
    effect: 'heal',
    health: 7,
    icon: 'potion',
    name: 'hp potion iii',
    price: 7,
    set: 2,
    size: '13px',
  },
  {
    effect: 'mana',
    icon: 'potion',
    mana: 7,
    name: 'mp potion iii',
    price: 7,
    set: 2,
    size: '13px',
  },
];
